module.exports = __webpack_public_path__ + "static/media/approve.747e2bb0.svg";